<template>
  <ThemeCustomizer>
    <h5 class="mb-4 theme-customizer-topic-title">Auth modal</h5>
    <ul class="list-unstyled mb-0">
      <li class="mb-4">
        <div class="mb-3">Layout Options</div>
        <div class="btn-group" role="group" aria-label="switch btn">
          <button
            v-for="layout in layoutList"
            :key="layout"
            type="button"
            class="btn"
            :class="[
              { active: data.selectedLayout === layout },
              customBtnOutlinePrimaryClass
            ]"
            @click.prevent="data.selectedLayout = layout"
          >
            layout {{ layout }}
          </button>
        </div>
      </li>
      <li>
        <div class="mb-3">Function</div>

        <div class="mb-1">Menu</div>
        <div class="mb-3">
          <div v-for="menu in menuList" :key="menu" class="mb-1 form-check">
            <input
              :id="`themeCustomizer${menu}`"
              v-model="data.selectedMenu"
              :class="customFormCheckInputClass"
              type="radio"
              :value="menu"
            />
            <label class="form-check-label" :for="`themeCustomizer${menu}`">{{
              menu
            }}</label>
          </div>
        </div>

        <div class="mb-1">Image</div>
        <div class="form-check" :class="customFormSwitchClass">
          <input
            id="themeCustomizerHasImg"
            v-model="data.hasImg"
            :class="customFormCheckInputClass"
            type="checkbox"
            role="switch"
          />
          <label class="form-check-label" for="themeCustomizerHasImg"
            >active</label
          >
        </div>
      </li>
    </ul>
    <div class="theme-customizer-line"></div>
    <ul class="list-unstyled mb-0">
      <li>
        <div class="mb-3">Sign in & Sign up</div>

        <div class="mb-1">Steppers</div>
        <div class="form-check" :class="customFormSwitchClass">
          <input
            id="themeCustomizerHasStep"
            v-model="data.hasStep"
            :class="customFormCheckInputClass"
            type="checkbox"
            role="switch"
          />
          <label class="form-check-label" for="themeCustomizerHasStep"
            >active</label
          >
        </div>
      </li>
    </ul>
    <div class="theme-customizer-line"></div>
    <div class="d-flex flex-column gap-2">
      <span>Image 建議尺寸</span>
      <div>
        LayoutA-Steppers(開啟)：500 x 760
        <br />
        LayoutA-Steppers(關閉)：992 x 200
      </div>
      <div>
        LayoutB-Desktop：960 x 1080
        <br />
        LayoutB-Mobile：992 x 200
      </div>
      <small>
        LayoutA-Steppers(關閉) 和 LayoutB-Mobile 是共用一張image
      </small>
    </div>
    <div class="theme-customizer-line"></div>
  </ThemeCustomizer>
</template>

<script>
import { computed, defineComponent } from '@nuxtjs/composition-api'
import ThemeCustomizer from './ThemeCustomizer.vue'

export default defineComponent({
  name: 'ThemeCustomizerAuthModal',
  props: {
    layoutList: {
      type: Array,
      default: () => ['A', 'B']
    },
    menuList: {
      type: Array,
      default: () => ['tabs', 'button']
    },
    settings: {
      type: Object,
      default: () => ({
        selectedLayout: 'A',
        hasImg: true,
        hasStep: true,
        selectedMenu: 'tabs'
      }),
      required: true
    },
    // custom class
    customBtnOutlinePrimaryClass: {
      type: String,
      default: 'btn-outline-primary'
    },
    customFormSwitchClass: {
      type: String,
      default: 'form-switch'
    },
    customFormCheckInputClass: {
      type: String,
      default: 'form-check-input'
    }
  },
  components: { ThemeCustomizer },
  setup(props, context) {
    const data = computed({
      get() {
        return props.settings
      },
      set(val) {
        context.emit('change', val)
      }
    })

    return {
      data
    }
  }
})
</script>
